module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "forward"
  }, [_c('div', {
    staticClass: "cite"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_0005"
    }
  }), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v("We express our gratitude to Allen Black, Ron Cox, Brian Faust, Josh Fleer, Spencer Furby, and Jonathan Woodall for their careful reading of the manuscripts in various stages of development; to Jody Fleischhut for her personable work with the Seminar, and to Jim and Caye Randolph for enabling so many of the Seminars participants.")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('span', [_vm._v("To the memories of Marvelyn Fleer and Leo and Mabel Perleth, my first community of faith and whose unconditional love sustains me long after their deaths. - David Fleer")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('span', [_vm._v("To the memories of J. P. Sanders, E. W. McMillan, and Delane Way who, as a young preacher, were my first elders and mentors in the faith and who showed me how to “run with endurance.” - Dave Bland")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15ce2574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780891128793_Part04.vue
// module id = 63
// module chunks = 0